import React, { createContext, useContext, useState } from 'react';

export const MenuContext = createContext();

export const MenuProvider = ({ children }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <MenuContext.Provider value={{ isMenuOpen, setIsMenuOpen }}>
            {children}
        </MenuContext.Provider>
    );
};

// export const useMenuContext = () => {
//     const context = useContext(MenuContext);
//
//     if (!context) {
//         throw new Error('useMenuContext must be used within a MenuProvider');
//     }
//
//     return context;
// };